// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../../shared/media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../../shared/core/domain/api-models/SharedApiModel.mjs";

function src_path_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = MediaApiModel$PorterinFeature.image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function campaign_image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_text"), null));
  if (alt_text.TAG === /* Ok */0) {
    var src_path = src_path_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src_path"), null));
    if (src_path.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt_text: alt_text._0,
                src_path: src_path._0
              }
            };
    }
    var e = src_path._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".src_path" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt_text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt_text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function campaign_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var has_button = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_button"), null));
  if (has_button.TAG === /* Ok */0) {
    var has_testimonial = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_testimonial"), null));
    if (has_testimonial.TAG === /* Ok */0) {
      var has_video = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_video"), null));
      if (has_video.TAG === /* Ok */0) {
        var campaign_image = campaign_image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_image"), null));
        if (campaign_image.TAG === /* Ok */0) {
          var cta = Decco.optionFromJson(SharedApiModel$PorterinFeature.know_more_cta_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cta"), null));
          if (cta.TAG === /* Ok */0) {
            var campaign_video = Decco.optionFromJson(SharedApiModel$PorterinFeature.know_more_cta_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_video"), null));
            if (campaign_video.TAG === /* Ok */0) {
              var testimonial = Decco.arrayFromJson(SharedApiModel$PorterinFeature.text_subtext_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "testimonial"), null));
              if (testimonial.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          has_button: has_button._0,
                          has_testimonial: has_testimonial._0,
                          has_video: has_video._0,
                          campaign_image: campaign_image._0,
                          cta: cta._0,
                          campaign_video: campaign_video._0,
                          testimonial: testimonial._0
                        }
                      };
              }
              var e = testimonial._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".testimonial" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = campaign_video._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".campaign_video" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = cta._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".cta" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = campaign_image._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".campaign_image" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = has_video._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".has_video" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = has_testimonial._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".has_testimonial" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = has_button._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".has_button" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var campaign_section = Decco.arrayFromJson(campaign_section_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_section"), null));
    if (campaign_section.TAG === /* Ok */0) {
      var terms_and_conditions = SharedApiModel$PorterinFeature.terms_and_conditions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "terms_and_conditions"), null));
      if (terms_and_conditions.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  campaign_section: campaign_section._0,
                  terms_and_conditions: terms_and_conditions._0
                }
              };
      }
      var e = terms_and_conditions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".terms_and_conditions" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = campaign_section._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".campaign_section" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = data_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  src_path_decode ,
  campaign_image_decode ,
  campaign_section_decode ,
  attributes_decode ,
  data_decode ,
  t_decode ,
}
/* No side effect */
